import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { map } from 'rxjs/operators/map'
import { JwtHelper, tokenNotExpired } from 'angular2-jwt'
import { Router } from '@angular/router'
import { AdminService } from './admin-service'
import { Subject } from 'rxjs/Subject'
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment'
@Injectable({
  providedIn: 'root'
})
export class AdminAuthService {
  baseUrl = environment.baseUrl
  url = this.baseUrl + 'admin';
  timer: any;
  authStatus: Subject<boolean> = new Subject<boolean>();
  constructor(private httpClient: HttpClient, private router: Router) { }
  login(credentials) {
    console.log(this.url)
    return this.httpClient.post<any>(this.url + '/login', credentials).pipe(
      map(response => {
        if (response && response.token) {
          const jwtHelpers = new JwtHelper();
          localStorage.setItem('admin-token', response.token);
          const expireTime = jwtHelpers.decodeToken(response.token).expiresIn
          this.timer = setTimeout(() => {
            this.logout()
          }, expireTime * 1000)
          return true;
        }
        return false
      })
    )
  }
  logout() {
    clearTimeout(this.timer)
    localStorage.removeItem('admin-token');
    this.router.navigate(['/login/admin'])
  }
  getUserName() {
    const jwtHelper = new JwtHelper()
    const token = localStorage.getItem('admin-token')
    if (!token) return ""
    let name = jwtHelper.decodeToken(token).firstName + " " + jwtHelper.decodeToken(token).lastName
    return name;
  }
  isLoggedIn() {
    return tokenNotExpired('admin-token')
  }
  getToken() {
    const token = localStorage.getItem('admin-token')
    if (!token) return '';
    return token
  }
  verify() {
    return this.httpClient.get<any>(this.url + '/isLoggedIn')
  }


}
